import React from 'react';
import './loading.css';

function Loader() {
  return (
    <div className="loader-container">
      <span className="loaderAbh"></span>
    </div>
  );
}

export default Loader;
